<template>
      <div>
            <!-- Headline -->
            <div class="flex xs-12 xs-middle">
                  <div class="flex xs-6 xs-left fs5 lh125 fw7 c1 mb2">{{ $t("other_holders") }}</div>
                  <div class="flex xs-6 xs-right lh125 c1 mb2">
                        <j-button
                              v-if="$store.state.settings.quotes.detail.hasAddOtherHolder && list.length > 0"
                              type="tertiary"
                              @click="$modal.show('addHolder')"
                        >
                              <crm-icon name="add" size="small" color="c2"/>
                              {{ $t("add_holder") }}
                        </j-button>
                  </div>
            </div>

            <!-- List of holders -->
            <div v-for="holder in list" :key="holder.id" class="mb2">
                  <core-entity-card :entity="holder" :isExpanded="false">
                        <div
                              v-if="$store.state.settings.quotes.detail.hasRemoveOtherHolder"
                              slot="footer"
                              class="flex xs-12 bt1 bc7 mt3"
                        >
                              <div class="flex mt3">
                                    <!-- Remove Holder Button -->
                                    <j-button
                                          type="error"
                                          size="xsmall"
                                          @click="removeHolder(holder.id)"
                                    >{{ $t("remove_holder") }}</j-button>
                              </div>
                        </div>
                  </core-entity-card>
            </div>

            <!-- Empty state -->
            <j-card v-if="list.length === 0" class="bg5 p3 ta2 fs3">
                  <div class="flex xs-12 xs-center lh125 c1">
                        <!-- Add Other Holder Button -->
                        <j-button
                              v-if="$store.state.settings.quotes.detail.hasAddOtherHolder"
                              type="primary"
                              size="xsmall"
                              @click="$modal.show('addHolder')"
                        >{{ $t("add_holder") }}</j-button>
                        <div v-else>{{ $t("errors.no_data")}}</div>
                  </div>
            </j-card>

            <!-- Modal for Add Other Holder -->
            <core-modal name="addHolder" :headline="$t('add_holder')">
                  <select-client
                        for="add_holder"
                        @saved="handleSave()"
                        @cancelled="$modal.hide('addHolder')"
                  />
            </core-modal>
      </div>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard/"
import CoreModal from "@/modules/core/components/CoreModal"
import SelectClient from "../components/SelectClient"
import api from "../api/"

export default {
	components: {
		CoreEntityCard,
		JCard,
		JButton,
		CrmIcon,
		CoreModal,
		SelectClient
	},

	props: {
		list: {
			type: Array,
			required: true,
			default: () => []
		}
	},

	methods: {
		handleSave() {
			this.$emit("afterAddHolder")
			this.$modal.hide("addHolder")
		},

		async removeHolder(holderId) {
			const policyId = this.$route.params.id
			const entityId = holderId

			this.isLoading = true
			const res = await api.removeOtherHolder({
				policyId,
				entityId
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("afterRemoveHolder")
		}
	}
}
</script>